import { createAction, createReducer } from '@reduxjs/toolkit'
import { apiCallBegan } from 'store/apiCalls'

// ACTIONS
const scorePanelRequested = createAction('scorePanel/requested')
const scorePanelReceived = createAction('scorePanel/received')
const scorePanelRequestFailed = createAction('scorePanel/requestFailed')

// REDUCER
export const initialState = {
  data: null,
  loading: false,
  error: false
}

const scorePanelReducer = createReducer(initialState, {
  [scorePanelRequested.type]: (state) => {
    state.loading = true
    state.error = false
  },
  [scorePanelReceived.type]: (state, action) => {
    state.loading = false
    state.data = action.payload
  },
  [scorePanelRequestFailed.type]: (state) => {
    state.loading = false
    state.error = true
  }
})

// THUNK
export const fetchScorePanel = (gameId) =>
  apiCallBegan({
    url: `games/${gameId}/score_panel`,
    method: 'get',
    onStart: scorePanelRequested.type,
    onSuccess: scorePanelReceived.type,
    onError: scorePanelRequestFailed.type
  })

// SELECTOR
export const selectScorePanel = (state) => state.scorePanel

export default scorePanelReducer
